import { RouteRecordRaw } from 'vue-router';

import { RoutePermission } from '@/router/route-permission';

const TransactionsOld = () => import('@/modules/transactions-old/pages/TransactionsPage.vue');

export const TRANSACTIONS: RouteRecordRaw = {
  path: '/dashboard/transactions',
  name: 'transactions',
  component: TransactionsOld,
  props: () => ({
    withDownloadReconcileStatement: true,
  }),
  meta: {
    permission: RoutePermission.TRANSACTIONS,
    translation: 'navigation.link.transactions',
    root: true,
    icon: 'icon-transactions',
  },
};
